export class CentralStationNewContactDto {
    ContactNumber: number;
    FirstName: string;
    LastName: string;
}